/* globals console, module, require */
/* jshint esversion:6, globalstrict:true */
'use strict';

const Marionette = require('backbone.marionette'),
    jQuery = require('jquery'),
    ContactsList = require('./contactsList'),
    templates = require('../utilities/handlebars').templates;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'administrators card card-body hidden'
    },
    childViewEvents: {
        'edit:end':    'onEditEnd',
        'edit:start':  'onEditStart',
        'edit:delete': 'onEditDelete',
        'edit:save':   'onEditSave'
        //
        // 'edit:end': function (options) {this.trigger('edit:end', options);},
        // 'edit:inProgress': function (options) {this.trigger('edit:inProgress', options);},
        // 'edit:start': function (options) {this.trigger('edit:start', options);}
    },
    events: {
        'click button': 'onClickButton'
    },
    regions: {
        contactsList: {el: 'div[name=contactsList]', replaceElement: true}
    },
    tagName: 'div',
    template: templates.administrators,
    //
    onEditEnd: function () {
        this.toggleAddEditDisable(false);
    },
    onEditStart: function () {
        this.toggleAddEditDisable(true);
    },
    onRender: function () {
        this.showChildView('contactsList', new ContactsList({type: 'administrator', title: 'administratorsTitle', display: 'administratorTitle'}));
        return this;
    },
    toggleAddEditDisable: function (disable) {
        console.log('administrators.toggleAddEditDisable');
        jQuery('[data-action=add]', this.$el).attr('disabled', disable);
        jQuery('[data-action=edit]', this.$el).attr('disabled', disable);
        jQuery('[data-action=select]', this.$el).attr('disabled', disable);
    }
});
